import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import './App.scss';
import PlayerContainer from './components/Player/PlayerContainer';
import PlayerLauncher from './components/PlayerLauncher/PlayerLauncher';

function App() {
	return (
		<div className="App">
			<Suspense fallback={<div>Loading...</div>}>
				<Switch>
					<Route path="/player" component={PlayerContainer} />
					<Route path="/" component={PlayerLauncher} />
					<Route path="*">
						<Redirect to="/" />
					</Route>
				</Switch>
			</Suspense>
		</div>
	);
}

export default App;
